import { ECommerceItem, ECommerceTransaction } from '../types';
import { convertObjectByDictionaries } from '../google-analytics/utils';
import {
  ECommerce4Item,
  ECommerce4Transaction,
  ItemGa4EcommerceToUaEcommerceMap,
  ItemUaEcommerceToGa4EcommerceMap,
  TransactionGa4EcommerceToUaEcommerceMap,
  TransactionUaEcommerceToGa4EcommerceMap,
} from './types';
import { reverseDictionary } from '../utils/object';

/**
 * Convert ecommerce transaction (GA4) to ecommerce transaction (UA)
 * Use only during migration
 * @param params
 * @returns
 */
export const getGa4FromUAEcommerceTransaction = (
  params: Partial<ECommerceTransaction> = {}
): Partial<ECommerce4Transaction> => {
  return convertObjectByDictionaries<
    Partial<ECommerceTransaction>,
    TransactionUaEcommerceToGa4EcommerceMap,
    TransactionGa4EcommerceToUaEcommerceMap,
    Partial<ECommerce4Transaction>
  >(
    params,
    eCommerceTransactionUAToGa4Mapping,
    eCommerceTransactionGa4ToUAMapping
  );
};

/**
 * Convert item transaction (GA4) to item transaction (UA)
 * Use only during migration
 * @param params
 * @returns
 */
export const getGa4FromUaEcommerceItem = (
  params: Partial<ECommerceItem> = {}
): ECommerce4Item => {
  return convertObjectByDictionaries<
    Partial<ECommerceItem>,
    ItemUaEcommerceToGa4EcommerceMap,
    ItemGa4EcommerceToUaEcommerceMap,
    Partial<ECommerce4Item>
  >(params, eCommerceItemUAToGa4Mapping, eCommerceItemGa4ToUAMapping);
};

/**
 * Map of (UA) ecommerce fields to (GA4) ecommerce fields
 */
export const eCommerceTransactionUAToGa4Mapping: TransactionUaEcommerceToGa4EcommerceMap =
  {
    id: 'transaction_id',
    affiliation: 'affiliation',
    revenue: 'value',
    tax: 'tax',
    shipping: 'shipping',
    coupon: 'coupon',
    totalAmount: null,
  } as const;

export const eCommerceItemUAToGa4Mapping: ItemUaEcommerceToGa4EcommerceMap = {
  id: 'item_id',
  name: 'item_name',
  category: 'item_category',
  brand: 'item_brand',
  variant: 'item_variant',
  coupon: 'coupon',
  price: 'price',
  quantity: 'quantity',
  dimension5: 'affiliation',
  dimension2: 'departure_date',
  dimension3: 'arrival_date',
  dimension6: 'transport_code',
} as const;

/**
 * Map of transaction (GA4) to transaction (UA)
 */
export const eCommerceTransactionGa4ToUAMapping: TransactionGa4EcommerceToUaEcommerceMap =
  reverseDictionary<
    TransactionUaEcommerceToGa4EcommerceMap,
    TransactionGa4EcommerceToUaEcommerceMap
  >(eCommerceTransactionUAToGa4Mapping);

/**
 * Map of item (GA4) to item (UA)
 */
export const eCommerceItemGa4ToUAMapping: Partial<ItemGa4EcommerceToUaEcommerceMap> =
  reverseDictionary<
    ItemUaEcommerceToGa4EcommerceMap,
    ItemGa4EcommerceToUaEcommerceMap
  >(eCommerceItemUAToGa4Mapping, {});
